module.exports = __webpack_public_path__ + "static/media/logo-leanbox-wms-new.52246beb.png";